import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import GalleryIsotope from '../../components/GalleryIsotope';
import PageHeader from '../../components/PageHeader';

function Gallery() {
  return (
    <div>
      {/* Preloader*/}
      {/* <div id="preloader">
         <div className="spinner">
            <div className="bounce1"></div>
         </div>
      </div> */}
      {/* /Preloader ends */}
      {/* <Navbar /> */}
      {/* Jumbotron */}
      <PageHeader title={`Our Gallery`} page={'Gallery'} pageUrl={'gallery'} />
      <div className="page pb-0">
        {/* /jumbotron */}
        {/* ==== Page Content ==== */}
        <GalleryIsotope />
      </div>
      {/* /page */}
      <Footer />
    </div>
  );
}
export default Gallery;
